import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";


import Modal from "../../../../../components/Modal";
import Input from "../../../../../components/Input";
import messages from "../../../../../assets/locale/messages";
import { 
    EnglishAndSpecialCharacters, 
    ArabicAndSpecialCharacters, 
    ATLEAST_TWO_ENGLISH_CHARACTERS, 
    ATLEAST_TWO_ARABIC_CHARACTERS 
} from "../../../../../utils/Patterns";
import {createSpecialtyRequest, updateSpecialtyRequest} from "../../../../../store/Specialties/actions";


const AddEditManualSpecialtyModal = ({
 open,
 setOpen,
 selectedSpecialty,
 setSelectedSpecialty,
 onSuccess
}) => {
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.locale.lang);
    const isLoading = useSelector((state) => state.loader);
    const { branches, shared } = messages[lang];

    const {
        values,
        handleSubmit,
        setFieldTouched,
        setFieldValue,
        resetForm,
        touched, 
        errors,
        dirty,
        isValid
    } = useFormik({
        initialValues:{
            specialtyNameEN: selectedSpecialty?.name_en || "",
            specialtyNameAR: selectedSpecialty?.name_ar || "",
        },
        validationSchema: Yup.object({
            specialtyNameEN: Yup.string()
            .required("required")
            .matches(EnglishAndSpecialCharacters, "englishAndSpecialCharacters")
            .matches(ATLEAST_TWO_ENGLISH_CHARACTERS, "atleastTwoEnglishCharacters"),  
            specialtyNameAR: Yup.string()
            .required("required")
            .matches(ArabicAndSpecialCharacters, "arabicAndSpecialCharacters")
            .matches(ATLEAST_TWO_ARABIC_CHARACTERS, "atleastTwoArabicCharacters"),
        }),
        onSubmit: async ({specialtyNameEN, specialtyNameAR}) => {
            if(!!selectedSpecialty?.id){
                dispatch(updateSpecialtyRequest(
                    { id: selectedSpecialty?.id,
                    data: {
                        title_en: specialtyNameEN.trim(),
                        title_ar: specialtyNameAR.trim(),
                    }},
                    ()=>{
                        onSuccess();
                        handleCancelOrClose();
                    }
            ))
            }else{
                dispatch(createSpecialtyRequest(
                    {
                        title_en: specialtyNameEN.trim(),
                        title_ar: specialtyNameAR.trim(),
                    },
                    ()=>{
                        onSuccess();
                        handleCancelOrClose();
                    }
            ))
            }
        }
    });

    useEffect(() => {
        setFieldValue("specialtyNameEN", selectedSpecialty?.name_en || "");
        setFieldValue("specialtyNameAR", selectedSpecialty?.name_ar || "");
    }, [selectedSpecialty]);
    

    const handleCancelOrClose = () => {
        resetForm({
            values: {
                specialtyNameEN: "",
                specialtyNameAR: ""
            }
        });
        setSelectedSpecialty(null);
        setOpen(false);
    };

    return(
        <Modal
            open={open}
            handleClose={handleCancelOrClose}
            title={<span className="fsize-26 fweight-400">{branches.addBranch.specialtiesAndServices[selectedSpecialty ? 'editSpecialty' : 'createNewSpecialty']}</span>}
            contentClass="mb-3 pb-2 text-primary"
            content={
                <form onSubmit={handleSubmit}>
                    <Input
                        id="specialtyNameEN"
                        name="specialtyNameEN"
                        type="text"
                        required
                        label={branches.addBranch.specialtiesAndServices.specialtyNameENTitle}
                        placeholder={branches.addBranch.specialtiesAndServices.specialtyNameENPlaceholder}
                        value={values['specialtyNameEN']}
                        onChange={(value) => {
                            setFieldTouched("specialtyNameEN");
                            setFieldValue("specialtyNameEN", value);
                        }}
                        inputWrapperClass="mb-4"
                        labelClassName="text-dark font-medium mb-2"
                        isInputHasErr={!!(touched["specialtyNameEN"] && errors["specialtyNameEN"])}
                        errMsg={errors["specialtyNameEN"]}
                    />
                    <Input
                        id="specialtyNameAR"
                        name="specialtyNameAR"
                        type="text"
                        required
                        label={branches.addBranch.specialtiesAndServices.specialtyNameARTitle}
                        placeholder={branches.addBranch.specialtiesAndServices.specialtyNameARPlaceholder}
                        value={values['specialtyNameAR']}
                        onChange={(value) => {
                            setFieldTouched("specialtyNameAR");
                            setFieldValue("specialtyNameAR", value);
                        }}
                        inputWrapperClass="mb-4"
                        labelClassName="text-dark font-medium mb-2"
                        isInputHasErr={!!(touched["specialtyNameAR"] && errors["specialtyNameAR"])}
                        errMsg={errors["specialtyNameAR"]}
                    />
                </form>
            }
            isContentText={false}
            maxWidth="sm"
            hasActions={true}
            confirmBtnTxt={shared.save}
            cancelBtnTxt={shared.cancel}
            actionsClass=" px-4"
            confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
            cancelBtnClass="fsize-14 py-2 text-secondary px-5 "
            disableActionBtn={!dirty || !isValid || isLoading}
            handleConfirm={()=>{handleSubmit()}}
            handleCancel={handleCancelOrClose}
        />
    )
};

export default AddEditManualSpecialtyModal;
